import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./index.css";
import "./i18n/i18n.ts";
import "@lucid/lego/index.scss";
import App from "./App.tsx";
import { captureSourceUrlFromQuery } from "./hooks/useBackNavigation";

const queryClient = new QueryClient();

// Must run before createRoot so Auth0 redirects do not drop incoming source query params.
captureSourceUrlFromQuery();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
